<!-- MODAL asignarMaquina -->
<div style="overflow-y: auto" mdbModal #asignarMaquina="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">Asignar máquina</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="asignarMaquina.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <form autocomplete="off" [formGroup]="formHeader">
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">Datos de la máquina</h5>
            </div>
          </div>

          <div class="row filtros-body">
            <div class="col dato" style="max-width: 200px">
              <Strong class="title">Origen</Strong>
              <span class="value">{{ movimiento?.ubicacion }}</span>
            </div>

            <div class="col" style="max-width: 200px">
              <Strong class="title">F. Asignación</Strong>
              <div class="md-form m-0">
                <mdb-date-picker [inline]="true" name="fechaAsignacionMaq" [placeholder]="'F. Asignación'" required
                  formControlName="fecha"> </mdb-date-picker>
                <div
                  *ngIf="formHeader.get('fecha').invalid && (formHeader.get('fecha').dirty || formHeader.get('fecha').touched)">
                  <mdb-error *ngIf="formHeader.get('fecha').hasError('required')"> Ingrese fecha </mdb-error>
                </div>
              </div>
            </div>

            <div class="col" style="max-width: 300px; margin-left: 5%">
              <Strong class="title">Asignación de equipo</Strong>
              <br />
              <span class="value">N° Placa: {{ movimiento?.numero_placa }}</span>
            </div>
          </div>

          <h5 class="mt-2" style="border-bottom: 1px solid #dee2e6">Datos destinatario</h5>

          <div class="row mt-2" formGroupName="destinatario">
            <div class="col" style="max-width: 200px">
              <div class="md-form">
                <mdb-select [options]="optionsTipoDestinatario" [multiple]="false" [filterEnabled]="true"
                  [highlightFirst]="false" placeholder="Seleccionar Tipo destinatario"
                  formControlName="tipoDestinatario">
                </mdb-select>
                <label>Tipo destinatario</label>
                <div
                  *ngIf="formHeader.get('destinatario.tipoDestinatario').invalid && (formHeader.get('destinatario.tipoDestinatario').dirty || formHeader.get('destinatario.tipoDestinatario').touched)">
                  <mdb-error *ngIf="formHeader.get('destinatario.tipoDestinatario').hasError('required')"> Ingrese tipo
                    destinatario </mdb-error>
                </div>
              </div>
            </div>

            <ng-container *ngIf="
                formHeader.get('destinatario.tipoDestinatario')?.value != 1 &&
                formHeader.get('destinatario.tipoDestinatario')?.value != 99 &&
                formHeader.get('destinatario.tipoDestinatario')?.value != 3
              ">
              <div class="col" style="max-width: 130px">
                <div class="md-form">
                  <input value="" type="text" id="rutcliente_" class="form-control" placeholder="9.999.999-9" required
                    #rutcliente_ formControlName="rutCliente" formatRut />
                  <label for="rutcliente_" *ngIf="formHeader.get('destinatario.tipoDestinatario')?.value != 99">Rut
                    cliente</label>
                  <div
                    *ngIf="formHeader.get('destinatario.rutCliente').invalid && (formHeader.get('destinatario.rutCliente').dirty || formHeader.get('destinatario.rutCliente').touched)">
                    <mdb-error *ngIf="formHeader.get('destinatario.rutCliente').hasError('required')"> Ingrese rut
                      cliente </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col" style="max-width: 300px" *ngIf="
                  formHeader.get('destinatario.tipoDestinatario')?.value != 1 &&
                  formHeader.get('destinatario.tipoDestinatario')?.value != 99 &&
                  formHeader.get('destinatario.tipoDestinatario')?.value != 3
                ">
                <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                  (click)="openModalSeleccionarcliente()">
                  <mdb-icon fas icon="search"></mdb-icon>
                </button>
                <h6 class="text-info" style="display: contents" *ngIf="cliente">
                  {{ cliente.razon_social }}
                </h6>
              </div>
            </ng-container>
            <ng-container
              *ngIf="formHeader.get('destinatario.tipoDestinatario')?.value != 1 && formHeader.get('destinatario.tipoDestinatario')?.value === 99">
              <div class="col" style="max-width: 200px">
                <div class="md-form">
                  <input value="" type="text" id="rutproveedor" class="form-control" placeholder="9.999.999-9" required
                    #rutproveedor formControlName="rutProveedor" formatRut />
                  <label for="rutProveedor" *ngIf="formHeader.get('destinatario.tipoDestinatario')?.value === 99">Rut
                    Proveedor</label>
                  <div *ngIf="
                      formHeader.get('destinatario.rutProveedor').invalid && (formHeader.get('destinatario.rutProveedor').dirty || formHeader.get('destinatario.rutProveedor').touched);
                      &quot;md-form&quot;
                    ">
                    <mdb-error *ngIf="formHeader.get('destinatario.rutProveedor').hasError('required')"> Ingrese rut
                      proveedor </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col d-flex" style="max-width: 400px"
                *ngIf="formHeader.get('destinatario.tipoDestinatario')?.value != 1 && formHeader.get('destinatario.tipoDestinatario')?.value === 99">
                <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                  (click)="openModalSeleccionarProveedor()">
                  <mdb-icon fas icon="search"></mdb-icon>
                </button>
                <h6 class="text-info" style="display: contents" *ngIf="proveedorSeleccionado">
                  {{ proveedorSeleccionado.nombre }}
                </h6>
              </div>
            </ng-container>
            <ng-container *ngIf="formHeader.get('destinatario.tipoDestinatario')?.value === 2">
              <div class="col" style="max-width: 300px">
                <div class="md-form">
                  <mdb-select [options]="optionsSucursal" [multiple]="false" [filterEnabled]="true"
                    [highlightFirst]="false" placeholder="Seleccionar Sucursal" formControlName="sucursal"></mdb-select>
                  <label>Dirección</label>
                  <div
                    *ngIf="formHeader.get('destinatario.sucursal').invalid && (formHeader.get('destinatario.sucursal').dirty || formHeader.get('destinatario.sucursal').touched)">
                    <mdb-error *ngIf="formHeader.get('destinatario.sucursal').hasError('required')"> Ingrese sucursal
                    </mdb-error>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>

          <div class="row mt-2" formGroupName="destinatario">
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="observacion" class="form-control" placeholder="Observación..."
                  maxlength="200" #observacion formControlName="observacion" />
                <label for="observacion">Observación</label>
              </div>
            </div>
          </div>

          <ng-container *ngIf="showPanels.descMov">
            <h5 class="mt-2" style="border-bottom: 1px solid #dee2e6">Descripción del movimiento</h5>
            <div formGroupName="movimiento">
              <h5 class="mt-2">
                <mdb-checkbox [checked]="false" formControlName="generar_guia">
                  <span style="font-size: 1rem">Generar guia</span>
                </mdb-checkbox>
              </h5>
              <div class="row">
                <div class="col" style="max-width: 300px">
                  <div class="md-form">
                    <mdb-select [options]="optionsTipoDoc" [multiple]="false" [filterEnabled]="false"
                      [highlightFirst]="false" placeholder="Guía de despacho" formControlName="tipoDte"> </mdb-select>
                    <label>Tipo de documento</label>
                  </div>
                </div>
                <div class="col" style="max-width: 300px"
                  *ngIf="formHeader.get('movimiento.tipoDte').value !== 52 || formHeader.get('movimiento.generar_guia').value === false">
                  <div class="md-form">
                    <input value="" type="text" id="ndoc" class="form-control" placeholder="N° Documento" #ndoc
                      formControlName="nroDoc" onlyNumbers />
                    <label for="ndoc">N° Documento</label>
                  </div>
                </div>
                <div class="col" style="max-width: 500px"
                  *ngIf="formHeader.get('movimiento.tipoDte').value === 52 && formHeader.get('movimiento.generar_guia').value === true">
                  <div class="md-form">
                    <input value="" type="text" id="descripcion" class="form-control" placeholder="Descripción"
                      maxlength="100" #descripcion formControlName="descripcion" />
                    <label for="descripcion">Descripción</label>
                    <div *ngIf="
                        formHeader.get('movimiento.tipoDte').value === 52 && formHeader.get('movimiento.generar_guia').value === true &&
                        formHeader.get('movimiento.descripcion').invalid &&
                        (formHeader.get('movimiento.descripcion').dirty || formHeader.get('movimiento.descripcion').touched)
                      ">
                      <mdb-error *ngIf="formHeader.get('movimiento.descripcion').hasError('required')"> Ingrese
                        Descripción </mdb-error>
                    </div>
                  </div>
                </div>

                <div class="col" style="max-width: 200px"
                  *ngIf="formHeader.get('movimiento.tipoDte').value !== 52 || formHeader.get('movimiento.generar_guia').value === false">
                  <Strong class="title">F. Guía de despacho</Strong>
                  <div class="md-form m-0">
                    <mdb-date-picker [inline]="true" name="fechaDocMovimientoMaq" [placeholder]="'F. Detalle'" required
                      formControlName="fecha"> </mdb-date-picker>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="showPanels.garantia">
            <h5 class="mt-2" style="border-bottom: 1px solid #dee2e6">Garantía</h5>

            <div class="row" formGroupName="garantia">
              <div class="col" style="max-width: 300px">
                <div class="md-form">
                  <mdb-select [options]="optionsTipoDocGarantia" [multiple]="false" [filterEnabled]="true"
                    [highlightFirst]="false" placeholder="Seleccionar tipo" formControlName="tipoDte">
                  </mdb-select>
                  <label>Tipo de documento</label>
                </div>
              </div>
              <div class="col" style="max-width: 300px">
                <div class="md-form">
                  <input value="" type="text" id="ndoc" class="form-control" placeholder="N° Documento" #ndoc
                    formControlName="nroDoc" onlyNumbers />
                  <label for="ndoc">N° Documento</label>
                </div>
              </div>
              <div class="col" style="max-width: 200px">
                <Strong class="title">F. Garantía</Strong>
                <div class="md-form m-0">
                  <mdb-date-picker [inline]="true" name="fechaGarantiaMaq" [placeholder]="'F. Garantía'" required
                    formControlName="fecha"> </mdb-date-picker>
                </div>
              </div>
            </div>

            <h5 class="mt-2" style="border-bottom: 1px solid #dee2e6" formGroupName="garantia">
              <mdb-checkbox [checked]="false" formControlName="contrato">
                <span style="font-size: 1rem">Contrato</span>
              </mdb-checkbox>
            </h5>

            <div class="row" formGroupName="garantia">
              <ng-container *ngIf="formHeader.get('garantia.contrato').value">
                <div class="col" style="max-width: 300px">
                  <div class="md-form mt-4">
                    <input value="" type="text" id="ncontrato" class="form-control" placeholder="N° Contrato" #ncontrato
                      formControlName="nroContrato" onlyNumbers />
                    <label for="ncontrato">N° Contrato</label>
                  </div>
                </div>
                <div class="col" style="max-width: 200px">
                  <Strong class="title">F. Contrato</Strong>
                  <div class="md-form m-0">
                    <mdb-date-picker [inline]="true" name="fechaDoc" [placeholder]="'Fecha Doc.'" required
                      formControlName="fechaDoc"> </mdb-date-picker>
                  </div>
                </div>
                <div class="col" style="max-width: 200px">
                  <Strong class="title">Vigencia desde</Strong>
                  <div class="md-form m-0">
                    <mdb-date-picker [inline]="true" name="vigDesde" [placeholder]="'Vigencia desde'"
                      formControlName="fechaVigenciaDesde"> </mdb-date-picker>
                  </div>
                </div>
                <div class="col" style="max-width: 200px">
                  <Strong class="title">Vigencia hasta</Strong>
                  <div class="md-form m-0">
                    <mdb-date-picker [inline]="true" name="vigHasta" [placeholder]="'Vigencia hasta'"
                      formControlName="fechaVigenciaHasta"> </mdb-date-picker>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <ng-container *ngIf="showPanels.entrega">
            <h5 class="mt-2" style="border-bottom: 1px solid #dee2e6">Entrega</h5>

            <div class="row align-items-center" formGroupName="entrega">
              <div class="col" style="max-width: 200px">
                <Strong class="title">F. Entrega</Strong>
                <div class="md-form m-0">
                  <mdb-date-picker [inline]="true" name="fechaEntregaConfirmacionMaq" [placeholder]="'F. Entrega'"
                    required formControlName="fechaConfirmacion"> </mdb-date-picker>
                  <div
                    *ngIf="formHeader.get('entrega.fechaConfirmacion').invalid && (formHeader.get('entrega.fechaConfirmacion').dirty || formHeader.get('entrega.fechaConfirmacion').touched)">
                    <mdb-error *ngIf="formHeader.get('entrega.fechaConfirmacion').hasError('required')"> Ingrese fecha
                      confirmación </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col">
                <mdb-checkbox [checked]="false" formControlName="esMovimientoCerrado">
                  <span style="font-size: 1rem">Movimiento cerrado</span>
                </mdb-checkbox>
              </div>
            </div>
          </ng-container>
        </div>
      </form>
      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="asignarMaquina.hide()" mdbWavesEffect>Cerrar</button>
        <button size="sm" type="button" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect
          (click)="guardar()">Guardar</button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" queryType="ONLY_RUT" (onSelectSingle)="onClienteSeleccionado($event)">
</app-modal-seleccionar-cliente>

<!-- MODAL seleccionarProveedor -->
<app-modal-seleccionar-proveedor (onSelect)="onProveedorSeleccionado($event)" [showFiltroActivoInactivo]="false"
  (onNotFound)="onProductoNoEncontrado()"> </app-modal-seleccionar-proveedor>
